import { render, staticRenderFns } from "./areaManagement.vue?vue&type=template&id=305e3401"
import script from "./areaManagement.vue?vue&type=script&lang=js"
export * from "./areaManagement.vue?vue&type=script&lang=js"
import style0 from "./areaManagement.vue?vue&type=style&index=0&id=305e3401&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('305e3401')) {
      api.createRecord('305e3401', component.options)
    } else {
      api.reload('305e3401', component.options)
    }
    module.hot.accept("./areaManagement.vue?vue&type=template&id=305e3401", function () {
      api.rerender('305e3401', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/freightmanager/areaManagement.vue"
export default component.exports